class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();

    this.onclick=e=>{
      if (e.target.classList.contains('slider-button--next')){
        e.target.closest('cart-drawer-items').lastElementChild.scrollLeft += e.target.closest('cart-drawer-items').lastElementChild.getBoundingClientRect().width;
      } else if (e.target.classList.contains('slider-button--prev')){
        e.target.closest('cart-drawer-items').lastElementChild.scrollLeft -= e.target.closest('cart-drawer-items').lastElementChild.getBoundingClientRect().width;
      }
    }
    this.onchange=e=>{
      if (e.target.type == 'radio'){
        if (e.target.src && e.target.src != ''){
          e.target.closest('.card-wrapper').querySelector('img.motion-reduce').src = e.target.src;
          e.target.closest('.card-wrapper').querySelector('img.motion-reduce').removeAttribute('srcset');
        }
        if (e.target.closest('variant-selects').children.length > 3){
          if (e.target.closest('.card-wrapper').querySelector('select>option[opt1="'+e.target.closest('.card-wrapper').querySelector('.opt1 input:checked').value+'"][opt2="'+e.target.closest('.card-wrapper').querySelector('.opt2 input:checked').value+'"][opt3="'+e.target.closest('.card-wrapper').querySelector('.opt3 input:checked').value+'"]') && 
             !e.target.closest('.card-wrapper').querySelector('select>option[opt1="'+e.target.closest('.card-wrapper').querySelector('.opt1 input:checked').value+'"][opt2="'+e.target.closest('.card-wrapper').querySelector('.opt2 input:checked').value+'"][opt3="'+e.target.closest('.card-wrapper').querySelector('.opt3 input:checked').value+'"]').disabled){
            e.target.closest('.card-wrapper').querySelector('button.product-form__submit').disabled = false;
            e.target.closest('.card-wrapper').querySelector('button.product-form__submit>span').innerText = e.target.closest('.card-wrapper').querySelector('button.product-form__submit').getAttribute('add');
          } else {
            e.target.closest('.card-wrapper').querySelector('button.product-form__submit').disabled = true;
            e.target.closest('.card-wrapper').querySelector('button.product-form__submit>span').innerText = e.target.closest('.card-wrapper').querySelector('button.product-form__submit').getAttribute('sold');
          }
          if (e.target.closest('.card-wrapper').querySelector('select>option[opt1="'+e.target.closest('.card-wrapper').querySelector('.opt1 input:checked').value+'"][opt2="'+e.target.closest('.card-wrapper').querySelector('.opt2 input:checked').value+'"][opt3="'+e.target.closest('.card-wrapper').querySelector('.opt3 input:checked').value+'"]')){
            e.target.closest('.card-wrapper').querySelector('select').value = e.target.closest('.card-wrapper').querySelector('select>option[opt1="'+e.target.closest('.card-wrapper').querySelector('.opt1 input:checked').value+'"][opt2="'+e.target.closest('.card-wrapper').querySelector('.opt2 input:checked').value+'"][opt3="'+e.target.closest('.card-wrapper').querySelector('.opt3 input:checked').value+'"]').value;
            fetch(e.target.closest('variant-selects').getAttribute('href') + e.target.closest('.card-wrapper').querySelector('select').value, {method: 'GET', credentials: 'include'}).then(response=>response.text()).then(html=>{
              const pdp = new DOMParser().parseFromString(html, 'text/html');
              if (pdp.querySelector('section.product__info-container button.product-form__submit').disabled){
                e.target.closest('.card-wrapper').querySelector('button.product-form__submit').disabled = true;
                e.target.closest('.card-wrapper').querySelector('button.product-form__submit>span').innerText = e.target.closest('.card-wrapper').querySelector('button.product-form__submit').getAttribute('sold');
              } else {
                e.target.closest('.card-wrapper').querySelector('button.product-form__submit').disabled = false;
                e.target.closest('.card-wrapper').querySelector('button.product-form__submit>span').innerText = e.target.closest('.card-wrapper').querySelector('button.product-form__submit').getAttribute('add');
              }
              e.target.closest('variant-selects').innerHTML = pdp.querySelector('.product__info-container>variant-selects').innerHTML;
            });
          } else {
            e.target.closest('.card-wrapper').querySelector('button.product-form__submit').disabled = false;
            e.target.closest('.card-wrapper').querySelector('button.product-form__submit>span').innerText = e.target.closest('.card-wrapper').querySelector('button.product-form__submit').getAttribute('add');
            e.target.closest('.card-wrapper').querySelector('select').value = e.target.closest('.card-wrapper').querySelector('select option[selected]').value;
            fetch(e.target.closest('variant-selects').getAttribute('href') + e.target.closest('.card-wrapper').querySelector('select option[selected]').value, {method: 'GET', credentials: 'include'}).then(response=>response.text()).then(html=>{
              e.target.closest('variant-selects').innerHTML = new DOMParser().parseFromString(html, 'text/html').querySelector('.product__info-container>variant-selects').innerHTML;
            });
          }
        } else if (e.target.closest('variant-selects').children.length > 2){
          if (e.target.closest('.card-wrapper').querySelector('select>option[opt1="'+e.target.closest('.card-wrapper').querySelector('.opt1 input:checked').value+'"][opt2="'+e.target.closest('.card-wrapper').querySelector('.opt2 input:checked').value+'"]') && 
             !e.target.closest('.card-wrapper').querySelector('select>option[opt1="'+e.target.closest('.card-wrapper').querySelector('.opt1 input:checked').value+'"][opt2="'+e.target.closest('.card-wrapper').querySelector('.opt2 input:checked').value+'"]').disabled){
            e.target.closest('.card-wrapper').querySelector('button.product-form__submit').disabled = false;
            e.target.closest('.card-wrapper').querySelector('button.product-form__submit>span').innerText = e.target.closest('.card-wrapper').querySelector('button.product-form__submit').getAttribute('add');
          } else {
            e.target.closest('.card-wrapper').querySelector('button.product-form__submit').disabled = true;
            e.target.closest('.card-wrapper').querySelector('button.product-form__submit>span').innerText = e.target.closest('.card-wrapper').querySelector('button.product-form__submit').getAttribute('sold');
          }
          if (e.target.closest('.card-wrapper').querySelector('select>option[opt1="'+e.target.closest('.card-wrapper').querySelector('.opt1 input:checked').value+'"][opt2="'+e.target.closest('.card-wrapper').querySelector('.opt2 input:checked').value+'"]')){
            e.target.closest('.card-wrapper').querySelector('select').value = e.target.closest('.card-wrapper').querySelector('select>option[opt1="'+e.target.closest('.card-wrapper').querySelector('.opt1 input:checked').value+'"][opt2="'+e.target.closest('.card-wrapper').querySelector('.opt2 input:checked').value+'"]').value;
            fetch(e.target.closest('variant-selects').getAttribute('href') + e.target.closest('.card-wrapper').querySelector('select').value, {method: 'GET', credentials: 'include'}).then(response=>response.text()).then(html=>{
              const pdp = new DOMParser().parseFromString(html, 'text/html');
              if (pdp.querySelector('section.product__info-container button.product-form__submit').disabled){
                e.target.closest('.card-wrapper').querySelector('button.product-form__submit').disabled = true;
                e.target.closest('.card-wrapper').querySelector('button.product-form__submit>span').innerText = e.target.closest('.card-wrapper').querySelector('button.product-form__submit').getAttribute('sold');
              } else {
                e.target.closest('.card-wrapper').querySelector('button.product-form__submit').disabled = false;
                e.target.closest('.card-wrapper').querySelector('button.product-form__submit>span').innerText = e.target.closest('.card-wrapper').querySelector('button.product-form__submit').getAttribute('add');
              }
              e.target.closest('variant-selects').innerHTML = pdp.querySelector('.product__info-container>variant-selects').innerHTML;
            });
          } else {
            e.target.closest('.card-wrapper').querySelector('button.product-form__submit').disabled = false;
            e.target.closest('.card-wrapper').querySelector('button.product-form__submit>span').innerText = e.target.closest('.card-wrapper').querySelector('button.product-form__submit').getAttribute('add');
            e.target.closest('.card-wrapper').querySelector('select').value = e.target.closest('.card-wrapper').querySelector('select option[selected]').value;
            fetch(e.target.closest('variant-selects').getAttribute('href') + e.target.closest('.card-wrapper').querySelector('select option[selected]').value, {method: 'GET', credentials: 'include'}).then(response=>response.text()).then(html=>{
              e.target.closest('variant-selects').innerHTML = new DOMParser().parseFromString(html, 'text/html').querySelector('.product__info-container>variant-selects').innerHTML;
            });
          }
        } else {
          if (e.target.closest('.card-wrapper').querySelector('select>option[opt1="'+e.target.closest('.card-wrapper').querySelector('.opt1 input:checked').value+'"]') && 
             !e.target.closest('.card-wrapper').querySelector('select>option[opt1="'+e.target.closest('.card-wrapper').querySelector('.opt1 input:checked').value+'"]').disabled){
            e.target.closest('.card-wrapper').querySelector('button.product-form__submit').disabled = false;
            e.target.closest('.card-wrapper').querySelector('button.product-form__submit>span').innerText = e.target.closest('.card-wrapper').querySelector('button.product-form__submit').getAttribute('add');
          } else {
            e.target.closest('.card-wrapper').querySelector('button.product-form__submit').disabled = true;
            e.target.closest('.card-wrapper').querySelector('button.product-form__submit>span').innerText = e.target.closest('.card-wrapper').querySelector('button.product-form__submit').getAttribute('sold');
          }
          if (e.target.closest('.card-wrapper').querySelector('select>option[opt1="'+e.target.closest('.card-wrapper').querySelector('.opt1 input:checked').value+'"]')){
            e.target.closest('.card-wrapper').querySelector('select').value = e.target.closest('.card-wrapper').querySelector('select>option[opt1="'+e.target.closest('.card-wrapper').querySelector('.opt1 input:checked').value+'"]').value;
            fetch(e.target.closest('variant-selects').getAttribute('href') + e.target.closest('.card-wrapper').querySelector('select').value, {method: 'GET', credentials: 'include'}).then(response=>response.text()).then(html=>{
              var pdp = new DOMParser().parseFromString(html, 'text/html');
              if (pdp.querySelector('section.product__info-container button.product-form__submit').disabled){
                e.target.closest('.card-wrapper').querySelector('button.product-form__submit').disabled = true;
                e.target.closest('.card-wrapper').querySelector('button.product-form__submit>span').innerText = e.target.closest('.card-wrapper').querySelector('button.product-form__submit').getAttribute('sold');
              } else {
                e.target.closest('.card-wrapper').querySelector('button.product-form__submit').disabled = false;
                e.target.closest('.card-wrapper').querySelector('button.product-form__submit>span').innerText = e.target.closest('.card-wrapper').querySelector('button.product-form__submit').getAttribute('add');
              }
              e.target.closest('variant-selects').innerHTML = pdp.querySelector('.product__info-container>variant-selects').innerHTML;
            });
          } else {
            e.target.closest('.card-wrapper').querySelector('button.product-form__submit').disabled = false;
            e.target.closest('.card-wrapper').querySelector('button.product-form__submit>span').innerText = e.target.closest('.card-wrapper').querySelector('button.product-form__submit').getAttribute('add');
            e.target.closest('.card-wrapper').querySelector('select').value = e.target.closest('.card-wrapper').querySelector('select option[selected]').value;
            fetch(e.target.closest('variant-selects').getAttribute('href') + e.target.closest('.card-wrapper').querySelector('select option[selected]').value, {method: 'GET', credentials: 'include'}).then(response=>response.text()).then(html=>{
              e.target.closest('variant-selects').innerHTML = new DOMParser().parseFromString(html, 'text/html').querySelector('.product__info-container>variant-selects').innerHTML;
            });
          }
        }
        if (e.target.closest('.card-wrapper').querySelector('select').options[e.target.closest('.card-wrapper').querySelector('select').selectedIndex].getAttribute('comprice') != '' &&
           e.target.closest('.card-wrapper').querySelector('select').options[e.target.closest('.card-wrapper').querySelector('select').selectedIndex].getAttribute('comprice') != e.target.closest('.card-wrapper').querySelector('select').options[e.target.closest('.card-wrapper').querySelector('select').selectedIndex].getAttribute('price')){
          e.target.closest('.card-wrapper').querySelector('s.price-item').innerText = e.target.closest('.card-wrapper').querySelector('select').options[e.target.closest('.card-wrapper').querySelector('select').selectedIndex].getAttribute('comprice');
          e.target.closest('.card-wrapper').querySelector('span.price-item--sale').innerText = e.target.closest('.card-wrapper').querySelector('select').options[e.target.closest('.card-wrapper').querySelector('select').selectedIndex].getAttribute('price');
          e.target.closest('.card-wrapper').querySelector('div.price').classList.add('price--on-sale');
        } else {
          e.target.closest('.card-wrapper').querySelector('span.price-item--regular').innerText = e.target.closest('.card-wrapper').querySelector('select').options[e.target.closest('.card-wrapper').querySelector('select').selectedIndex].getAttribute('price');
          e.target.closest('.card-wrapper').querySelector('div.price').classList.remove('price--on-sale');
        }
      }
    }
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
